import React, { useState, useEffect } from 'react';
import { ShieldCheck, Server, Activity, Clock, CheckCircle2, Lock } from 'lucide-react';
import './NocDashboard.css';

function NocDashboard() {
  const [ping, setPing] = useState(14);
  const [activeThreatsBlocked, setActiveThreatsBlocked] = useState(1420);

  useEffect(() => {
    const interval = setInterval(() => {
      setPing(Math.floor(Math.random() * 6) + 12);
      setActiveThreatsBlocked(prev => prev + Math.floor(Math.random() * 2));
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="noc-dashboard-card">
      <div className="noc-card-header">
        <div className="noc-status-indicator">
          <span className="pulsating-dot"></span>
          <span className="noc-status-text">24/7 Live NOC/SOC Operations</span>
        </div>
        <span className="noc-sla-tag">⚡ 15-Min SLA</span>
      </div>

      <div className="noc-metrics-grid">
        <div className="noc-metric-box">
          <div className="metric-header">
            <Activity size={16} className="metric-icon text-cyan" />
            <span>Avg SLA Response</span>
          </div>
          <div className="metric-value text-cyan">3m 45s</div>
          <small className="metric-sub text-green">✓ Guaranteed &lt;15m</small>
        </div>

        <div className="noc-metric-box">
          <div className="metric-header">
            <Server size={16} className="metric-icon text-green" />
            <span>System Uptime</span>
          </div>
          <div className="metric-value text-green">99.99%</div>
          <small className="metric-sub">Latency: {ping}ms</small>
        </div>
      </div>

      <div className="noc-compliance-row">
        <div className="compliance-badge">
          <ShieldCheck size={14} className="badge-icon" />
          <span>SOC2 Type II</span>
        </div>
        <div className="compliance-badge">
          <Lock size={14} className="badge-icon" />
          <span>HIPAA Compliant</span>
        </div>
        <div className="compliance-badge">
          <CheckCircle2 size={14} className="badge-icon" />
          <span>24/7 MDR SOC</span>
        </div>
      </div>

      <div className="noc-activity-feed">
        <div className="activity-title">Live Security & Network Log</div>
        <div className="activity-item">
          <span className="log-time">Just now</span>
          <span className="log-desc text-green">✓ Automated RMM Patch Deployed (Zero Downtime)</span>
        </div>
        <div className="activity-item">
          <span className="log-time">2m ago</span>
          <span className="log-desc text-blue">🛡️ {activeThreatsBlocked.toLocaleString()} Threats Blocked via Endpoint Security</span>
        </div>
      </div>
    </div>
  );
}

export default NocDashboard;
